import { z } from 'zod';

import type { ChargingConfiguration } from '#domain/ChargingDetails.ts';

export const ChargingConfigurationFormSchema = z
    .object({
        mode: z.enum(['target_percentage', 'fixed_duration']),
        target_percentage: z.number().gt(0).lte(100).optional(),
        charging_duration_seconds: z.number().int().gte(1).lte(86400).optional(),
        charger_power_kw: z.number().gt(0).lte(2000).optional(),
        connector_type: z.enum(['iec62196Type2Combo', 'iec62196Type2', 'chademo']).optional(),
        voltage_v: z.number().gt(0).lte(2000).optional(),
        current_a: z.number().gt(0).lte(5000).optional(),
        supply_type: z.enum(['dc', 'acSingle', 'acThree']).optional(),
    })
    .superRefine((value, ctx) => {
        const valid =
            value.mode === 'target_percentage'
                ? value.target_percentage !== undefined && value.charging_duration_seconds === undefined
                : value.charging_duration_seconds !== undefined && value.target_percentage === undefined;
        if (!valid) {
            ctx.addIssue({ code: z.ZodIssueCode.custom, message: 'Invalid charging configuration' });
        }
    }) satisfies z.ZodType<ChargingConfiguration>;
